import { ERentioFormField } from "../../components/components/Form";
import { getValue } from "../../redux/form/form.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { EField } from "./schema.signInToken.types";
export var getSchema = function (initialValues) {
    return function (defaultValues) {
        var _a;
        return ({
            required: [EField.Token],
            properties: (_a = {},
                _a[EField.Token] = {
                    default: getValue(EField.Token, initialValues, defaultValues),
                },
                _a),
        });
    };
};
export var uiSchema = function () {
    var _a;
    return (_a = {
            "rentio:trackingKey": "sign-in-token"
        },
        _a[EField.Token] = {
            "ui:field": ERentioFormField.Text,
            title: getLocalizedText("auth.token.label"),
            placeholder: getLocalizedText("auth.token.label"),
        },
        _a);
};
